"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureFlag = void 0;
const react_1 = require("react");
const configCat_1 = require("../../services/configCat");
const SessionControl_1 = require("../../utils/helpers/session/SessionControl");
function useFeatureFlag(key, defaultValue = false) {
    const [flag, setFlag] = (0, react_1.useState)(defaultValue);
    const [loading, setLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        (0, configCat_1.getValueConfigCat)({
            key,
            default: defaultValue,
            userIdentifier: SessionControl_1.User.getInstance().getUserId(),
        })
            .then((f) => {
            setFlag(f);
        })
            .catch(() => {
            setFlag(defaultValue);
        })
            .finally(() => {
            setLoading(false);
        });
    }, [key, defaultValue]);
    return [flag, loading];
}
exports.useFeatureFlag = useFeatureFlag;
